import { objectSchema, ObjectSchema } from "utils/object-methods";
import { TransferirSaldoParams } from ".";
import { fieldValidation } from "utils/field-validation";
import React, { Dispatch } from "react";
import { Toast } from "components/toast";
import { RowEmpresaProps } from "components/atendimentos-components/attendance-filter/types";
import api from "api/api";
import { User } from "contexts/types/application-context-types";
import { DropdownOptionProps } from "components/dropdown";

export function validateTransferirSaldo(params: TransferirSaldoParams) {
  const schema: ObjectSchema<TransferirSaldoParams> = {
    customerIdCredito: (value) => {
      const { isValid, errorMessage } = fieldValidation({ value }).required({
        message: "Preencha o campo",
      });

      return { valid: isValid, message: errorMessage };
    },
    tipoCarteiraCredito: (value) => {
      const { isValid, errorMessage } = fieldValidation({ value }).required({
        message: "Preencha o campo",
      });

      return { valid: isValid, message: errorMessage };
    },
    customerIdDebito: (value) => {
      const { isValid, errorMessage } = fieldValidation({ value }).required({
        message: "Preencha o campo",
      });

      return { valid: isValid, message: errorMessage };
    },
    tipoCarteiraDebito: (value) => {
      const { isValid, errorMessage } = fieldValidation({ value }).required({
        message: "Preencha o campo",
      });

      return { valid: isValid, message: errorMessage };
    },
    valor: (value) => {
      const { isValid, errorMessage } = fieldValidation({ value }).required({
        message: "Preencha o campo",
      });

      return { valid: isValid, message: errorMessage };
    },
  };

  return objectSchema(schema, params);
}

export async function loadEmpresas({
  setLoadingEmpresas,
  user,
  setEmpresas,
}: {
  setLoadingEmpresas: React.Dispatch<React.SetStateAction<boolean>>;
  user: User;
  setEmpresas: Dispatch<React.SetStateAction<DropdownOptionProps[]>>;
}) {
  setLoadingEmpresas(true);
  try {
    const { data } = await api.get<RowEmpresaProps[]>(`/customers`);
    setEmpresas([
      ...data.map(({ id, name, codigoNova }) => {
        if (user.userData.type === "PARCEIRO_GERENTE_VAREJO") {
          return { name: name, value: id };
        }
        return { name: `${codigoNova} - ${name}`, value: id };
      }),
    ]);
  } catch (e) {
    Toast({ title: "Erro ao carregar empresas", status: "error" });
  } finally {
    setLoadingEmpresas(false);
  }
}
